import { Link } from 'react-router-dom';
import { LogIn, LogOut, ChevronRight, Shield, Globe, Palette, Info } from 'lucide-react';
import { useAuth } from '@/shared/state/auth-context';
import { Avatar } from '@/shared/ui/Avatar';

export function Settings() {
  const { currentUser, signOut } = useAuth();
  return (
    <div data-testid="settings" className="px-4 pb-16">
      <h1 className="font-serif italic text-2xl text-white mb-6">Settings</h1>

      <section className="glass rounded-2xl p-4 mb-6">
        {currentUser ? (
          <div className="flex items-center gap-3">
            <Avatar src={currentUser.avatar} alt={currentUser.username} size={56} ring="rose" />
            <div className="flex-1">
              <div className="text-white font-medium">{currentUser.displayName}</div>
              <div className="text-white/50 text-xs">@{currentUser.username}</div>
            </div>
            <button data-testid="settings-signout" onClick={signOut} className="text-rose-300 text-sm flex items-center gap-1">
              <LogOut className="w-3.5 h-3.5" /> Sign out
            </button>
          </div>
        ) : (
          <Link to="/login" className="flex items-center gap-3">
            <div className="w-14 h-14 rounded-full glass flex items-center justify-center">
              <LogIn className="w-5 h-5 text-rose-300" />
            </div>
            <div className="flex-1">
              <div className="text-white font-medium">Sign in to PikPok</div>
              <div className="text-white/50 text-xs">Optional — guest mode is fully featured.</div>
            </div>
            <ChevronRight className="w-4 h-4 text-white/40" />
          </Link>
        )}
      </section>

      <SectionHeading>Preferences</SectionHeading>
      <Row icon={<Palette className="w-4 h-4 text-white/60" />} label="Theme" hint="Dark (locked)" />
      <Row icon={<Globe className="w-4 h-4 text-white/60" />} label="Language" hint="English" />
      <Row icon={<Shield className="w-4 h-4 text-white/60" />} label="Privacy" hint="Standard" />

      <SectionHeading>About</SectionHeading>
      <Row icon={<Info className="w-4 h-4 text-white/60" />} label="PikPok" hint="v8.6" />
    </div>
  );
}

function SectionHeading({ children }: { children: React.ReactNode }) {
  return <div className="text-[11px] uppercase tracking-widest text-white/40 mt-6 mb-2 px-1">{children}</div>;
}
function Row({ icon, label, hint }: { icon: React.ReactNode; label: string; hint?: string }) {
  return (
    <div className="flex items-center gap-3 py-3 border-b border-white/[0.06]">
      <div className="w-8 h-8 rounded-lg glass flex items-center justify-center">{icon}</div>
      <div className="flex-1 text-sm text-white/90">{label}</div>
      {hint && <div className="text-xs text-white/40">{hint}</div>}
      <ChevronRight className="w-4 h-4 text-white/30" />
    </div>
  );
}
